export default __webpack_public_path__ + "static/media/Age 1.9eddc73c.mp3";